import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
@Component({
  selector: "app-download-app",
  templateUrl: "./download-app.component.html",
  styleUrls: ["./download-app.component.scss"],
})
export class DownloadAppComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit() {}
  goToApp() {
    this.router.navigate(["/download-app-ios"]);
  }
}
